const VERSION = '0.1.0'
export default VERSION
